export default "__VITE_ASSET___5d3HLsP__"